var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.207,
    height: 12.46,
    viewBox: "0 0 25.207 12.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-977 -2182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35569",
    "data-name": "Group 35569",
    transform: "translate(977 2182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64106",
    "data-name": "Path 64106",
    d: "M998.468,2184.581a16.512,16.512,0,0,0-17.728,0,3.65,3.65,0,1,0,0,7.3,16.512,16.512,0,0,0,17.728,0,3.65,3.65,0,1,0,0-7.3Zm-13.534,3.649a4.677,4.677,0,1,1,1.37,3.3A4.648,4.648,0,0,1,984.933,2188.23Z",
    transform: "translate(-977 -2182)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64107",
    "data-name": "Path 64107",
    d: "M2885.077,2882.539a2.546,2.546,0,1,0-.746,1.793A2.51,2.51,0,0,0,2885.077,2882.539Z",
    transform: "translate(-2869.935 -2876.308)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.76f57cfca78d6d96ce72062303f1acaa.svg";
export { ForwardRef as ReactComponent };